import { UserResource } from '@aorg/models/resources/UserResource';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Session } from '../models/session';
import type { RootState } from '../store';

const initialState: Session = {
  token: undefined,
  isAuthenticated: false,
  user: undefined,
  admin: undefined,
  appVersion: undefined,
  loadingComplete: false,
};

const setup = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession(state, { payload }: PayloadAction<Partial<Session>>) {
      return { ...state, ...payload };
    },
    setSessionUser(state, { payload }: PayloadAction<Session['user']>) {
      return { ...state, user: payload };
    },
    setAdminSessionUser(state, { payload }: PayloadAction<Session['admin']>) {
      return { ...state, admin: payload };
    },
    setSessionUserStatus(
      state,
      { payload }: PayloadAction<UserResource['status']>
    ) {
      return { ...state, user: { ...state.user!, status: payload } };
    },
    setSessionToken(state, { payload }: PayloadAction<string>) {
      return { ...state, token: payload };
    },
    setSessionAuth(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isAuthenticated: payload };
    },
    setSessionAppVersion(
      state,
      { payload }: PayloadAction<string | undefined>
    ) {
      return { ...state, appVersion: payload };
    },
    setLoadingComplete(state, { payload }: PayloadAction<boolean>) {
      return { ...state, loadingComplete: payload };
    },

    setSessionClear() {
      return initialState;
    },
  },
});

export const {
  setSession,
  setSessionUser,
  setAdminSessionUser,
  setSessionClear,
  setSessionUserStatus,
  setSessionToken,
  setSessionAppVersion,
  setLoadingComplete,
  setSessionAuth,
} = setup.actions;

export const selectSession = ({ session }: RootState) => session;
export const selectSessionUser = ({ session }: RootState) => session.user;
export const selectSessionAdmin = ({ session }: RootState) => session.admin;
export const selectSessionToken = ({ session }: RootState) => session.token;
export const selectSessionAuth = ({ session }: RootState) =>
  session.isAuthenticated;
export const selectSessionAppVersion = ({ session }: RootState) =>
  session.appVersion;
export const selectLoadingComplete = ({ session }: RootState) =>
  session.loadingComplete;

export default setup.reducer;
